import React, { ReactElement } from 'react';
import PromptModal from 'components/common/Modals/PromptModal';
import FileViewer from '@monorepo/shared/src/components/common/FileViewer';

type Props = {
  file: any;
  onAccept: () => void;
  onReject: () => void;
};
const PreviewSubmissionModal = ({ file, onAccept, onReject }: Props): ReactElement => {
  return (
    <PromptModal onAccept={onAccept} onReject={onReject}>
      <FileViewer files={[file]} />
    </PromptModal>
  );
};

export default PreviewSubmissionModal;
